<template>
  <div id="SalesList" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 fixed-t">
      <div class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 bb1">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">V</span>entas</div>
        <div class="col-3 t-r f22 pr3"></div>        
      </div>
      <div class="col-12 bg-color-white pl10 pr10 pt5 pb5 uppercase f14">
        <div class="col-4 color-muted pt8 pb8 t-c" @click="go_ext()" v-if="!$store.state.page_ext_args.ext_name">Caja<i class="iconfont icon-arrow-down-filling color-muted"></i></div>
        <div class="col-4 color-muted pt8 pb8 t-c el" v-else @click="del_page_args()">{{$store.state.page_ext_args.ext_name}} <i class="iconfont icon-error color-muted"></i></div>
        <div class="col-4 color-muted pt8 pb8 t-c" @click="go_user(2)" v-if="!$store.state.page_cashier_args.cashier_name">Cajera(o)<i class="iconfont icon-arrow-down-filling color-muted"></i></div>
        <div class="col-4 color-muted pt8 pb8 t-c el" v-else @click="del_page_args(2)">{{$store.state.page_cashier_args.cashier_name}} <i class="iconfont icon-error color-muted"></i></div>
        <div class="col-4 color-muted pt8 pb8 t-c" @click="go_user(3)" v-if="!$store.state.page_salesman_args.salesman_name">Vendedor<i class="iconfont icon-arrow-down-filling color-muted"></i></div>
        <div class="col-4 color-muted pt8 pb8 t-c el1" v-else @click="del_page_args(3)">{{$store.state.page_salesman_args.salesman_name}} <i class="iconfont icon-error color-muted"></i></div>
      </div>
      <div class="col-12 bg-color1 pt5 pb5 pl10 pr10 f12">
        <div class="col-3 t-c pt8 pb8 r10 b-s-1" :class="{'bg-color-primary color-white':data_status == 0,'color-muted':data_status != 0}" @click="statusCh(0)">Todas</div>
        <div class="col-3 t-c pt8 pb8 r10 b-s-1" :class="{'bg-color-success color-white':data_status == 1,'color-muted':data_status != 1}" @click="statusCh(1)">Completado</div>
        <div class="col-3 t-c pt8 pb8 r10 b-s-1" :class="{'bg-color-warning color-white':data_status == 2,'color-muted':data_status != 2}" @click="statusCh(2)">Modificado</div>
        <div class="col-3 t-c pt8 pb8 r10 b-s-1" :class="{'bg-color-danger color-white':data_status == 3,'color-muted':data_status != 3}" @click="statusCh(3)">Eliminado</div>
      </div>
    </div>
    <div class="h12"></div>
    <div class="col-12 pt3 pb10 bg-color1" style="overflow-y: auto;">
      <div ref="myDiv" class="col-12 pl5 pr5 mt5" :class="{'bl5-primary': sale.sale_type > 0,'bl5-warning': sale.sale_type === -2,'bl5-danger': sale.sale_type === -1}" v-for="(sale,sale_i) in data_list" v-bind:key="sale_i" @click="go_sale(sale.id)">
        <div class="col-12">
          <div class="col-12 bg-color-white p5">
              <div class="col-9 pl10">
                <div class="col-12 uppercase f14"><span class="fw">#{{ sale.sale_no }}</span>  {{ sale.extension_name }} </div>
                <div class="col-12 f14 fw uppercase el1">{{ sale.client_name }}</div>
                <div class="col-12 color-muted f14"> <span class="color-muted f12">{{ sale.update_time }}</span></div>
              </div>
              <div class="col-3 t-r lh50" :class="{'color-black': sale.sale_type != -1,'color-warning': sale.sale_type === -1 && sale.to_sale_id > 0,'color-danger': sale.sale_type === -1 && sale.to_sale_id === 0}">
                <span v-if="sale.sale_type == -1">-</span>
                <span class="f12">{{ $store.state.currency[$store.state.pos.currency_on].currency_code }}</span><span v-if="$store.state.pos.currency_on == 1">{{ fun.formatMoney(sale.total_ex1,2) }}</span> <span v-else>{{ fun.formatMoney(sale.total,2) }}</span>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 t-c pt10 pb10">
      <page-component :page-config="pageConfigTotal" @changeCurrentPage="changePage"></page-component>
    </div>
  </div>
</template>
<script>
import pageComponent from "../pageComponent"
export default {
  name: 'SalesList',
  data () {
    return {
      keyword: '',
      data_list: [],
      data_status: 0,
      data_page: 1,
      pageConfigTotal:{total:0,pageSize:20,pageNo:1},
    }
  },
  created: function () {
    this.get_list_data();
  },
  methods: {
    get_list_data() {
      var keyword = this.keyword;
      if(keyword < 2){
        //return;
      }
      var post_data = {};
      post_data.keyword = keyword;
      post_data.page = this.data_page - 1;
      post_data.status = this.data_status;
      post_data.ext_id = this.$store.state.page_ext_args.ext_id;
      post_data.cashier_id = this.$store.state.page_cashier_args.cashier_id;
      post_data.salesman_id = this.$store.state.page_salesman_args.salesman_id;
      if(post_data.page < 0){
        post_data.page = 0;
      }
      this.post(this.api_url + 'manage/sales', post_data).then((res)=>{
        if(res.status == 1){
          this.data_list = res.data.sales;
          this.pageConfigTotal.total = res.data.sales_count;
        }else{
          this.data_list = []
        }
      })
    },
    changePage(page){
      this.pageConfigTotal.pageNo = page
      this.data_page = page;
      this.get_list_data();
    },
    statusCh(status){
      if(this.data_status == status){
        return;
      }
      this.data_status = status;
      this.get_list_data();
    },
    //选择销售端
    go_ext(){
      this.$router.push({name:'M_ExtensionsSelect'});
    },
    //选择用户
    go_user(user_type){
      this.$router.push({name:'M_UsersSelect',query:{user_type: user_type}});
    },
    //查看销售详情
    go_sale(id){
      this.$router.push({name:'M_Sale',query:{from:this.$route.name, id: id}});
    },
    del_page_args(arg_type){
      if(arg_type == 2){
        this.$store.commit('setPageCashierArgs',{cashier_id:0,cashier_name:''});
      }else if(arg_type == 3){
        this.$store.commit('setPageSalesmanArgs',{salesman_id:0,salesman_name:''});
      }else{
        this.$store.commit('setPageExtArgs',{ext_id:0,ext_name:''});
      }
      this.get_list_data();
    }
  },
  components:{'page-component':pageComponent}
}
</script>



// WEBPACK FOOTER //
// src/components/Main/SalesList.vue